// src/api/seo/seoMetaService.js
import client from '../client';

/**
 * GET /api/public/farms/:id/seo
 *
 * @param {string | number} farmId
 * @returns {Promise<{
 *   metaTitle: string,
 *   metaDescription: string,
 *   canonical: string,
 *   ogTitle: string,
 *   ogDescription: string,
 *   ogImage: string,
 *   ogType: string,
 * }>}
 */
export function getFarmSeoMeta(farmId) {
  return client
    .get(`/api/public/farms/${farmId}/seo`)
    .then(res => res.data);
}

/**
 * GET /api/public/experiences/:id/seo
 *
 * @param {string | number} experienceId
 * @returns {Promise<{
 *   metaTitle: string,
 *   metaDescription: string,
 *   canonical: string,
 *   ogTitle: string,
 *   ogDescription: string,
 *   ogImage: string,
 *   ogType: string,
 * }>}
 */
export function getExperienceSeoMeta(experienceId) {
  return client
    .get(`/api/public/experiences/${experienceId}/seo`)
    .then(res => res.data);
}
